/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { useSelector } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { Loader } from '@components/screen/Layout';
import Colors from '@global/colors';
import MessageItem from './MessageItem';

const CommentList = ({
  loading,
  comments,
  hasMore,
  onLoadMore,
  onEdit,
  onDelete,
  onOpenManage,
  getListRect,
  editingId,
  onEditingChange,
}) => {
  const currentUser = useSelector((state) => state.auth.user);

  if (loading && !comments.length) {
    return (
      <View style={{ padding: 30, alignItems: 'center' }}>
        <Loader />
      </View>
    );
  }

  if (!comments.length) {
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          padding: 30,
        }}>
        <Image
          source={require('@assets/img/icons/comment-grey.svg')}
          style={{ width: 40, height: 40, marginBottom: 12 }}
          width={40}
          height={40}
          svg={true}
        />
        <SociollaText type="medium" style={{ fontSize: 14, marginBottom: 4 }}>
          No comments yet.
        </SociollaText>
        <SociollaText
          style={{ fontSize: 12, color: Colors.grey1, textAlign: 'center' }}>
          Start the conversation by adding a comment.
        </SociollaText>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      {hasMore ? (
        <TouchableOpacity
          testID="comment-load-more"
          onPress={onLoadMore}
          style={{ padding: 12, alignItems: 'center' }}>
          <SociollaText style={{ fontSize: 12, color: Colors.blue0 }}>
            Load earlier comments
          </SociollaText>
        </TouchableOpacity>
      ) : (
        false
      )}
      {comments.map((comment, idx) => (
        <MessageItem
          key={comment._id}
          comment={comment}
          isOwn={String(comment.user_id) === String(currentUser?._id)}
          onEdit={onEdit}
          onDelete={onDelete}
          onOpenManage={onOpenManage}
          getListRect={getListRect}
          isEditing={editingId === comment._id}
          canManage={!editingId}
          onEditingChange={(editing) =>
            onEditingChange(editing ? comment._id : null)
          }
        />
      ))}
    </View>
  );
};

export default CommentList;
